export const track = (eventName, params = {}) => {
  if (window.fbq) window.fbq("trackCustom", eventName, params);
};

export const trackStandard = (eventName, params = {}) => {
  if (window.fbq) window.fbq("track", eventName, params);
};
